import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

const GAME_TIME = 60;
const WIDTH = 372;
const HEIGHT = 19;

export default class PercentageBar extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.barBackground = this.scene.add.graphics({ fillStyle: { color: 0xffffff } });
        this.barBackground.fillRoundedRect(-WIDTH / 2, -HEIGHT / 2, WIDTH, HEIGHT, 10);
        this.add(this.barBackground);

        this.fill = this.scene.add.graphics({ fillStyle: { color: 0x1a75ba } });
        this.fill.fillRoundedRect(-WIDTH / 2, -HEIGHT / 2, WIDTH, HEIGHT, 10);
        this.add(this.fill);

        this._maskGraphic = this.scene.add.graphics({ fillStyle: { color: 0xffffff }, x: x - WIDTH / 2, y: y - HEIGHT / 2 });
        this._maskGraphic.fillRect(0, 0, WIDTH, HEIGHT).setScale(0.5, 1).setVisible(false);
        this._mask = this._maskGraphic.createGeometryMask();
        this.fill.setMask(this._mask);

        this.remainingTime = GAME_TIME;
        this.totalSeconds = 0;
        this._isRunning = false;
    }

    start()
    {
        this.remainingTime = GAME_TIME;
        this._isRunning = true;
    }

    stop()
    {
        this._isRunning = false;
    }

    preUpdate(time, delta)
    {
        if (!this._isRunning) return;

        this.remainingTime -= delta / 1000;

        let percentTimeUsed = ((GAME_TIME - this.remainingTime) * 100 / GAME_TIME);

        this.showPercent(percentTimeUsed);
    }

    showPercent(percent)
    {
        percent = Phaser.Math.Clamp(percent, 0, 100);
        if (percent >= 100)
        {
            percent = 100;
            this.stop();

            this.emit(TIMER_DONE);
        }

        this._maskGraphic.setPosition(this.x - WIDTH / 2, this.y - HEIGHT / 2).setScale(percent / 100, 1);
    }
}

export const TIMER_DONE = "timerdone";